<div class="container-fluid col-12 col-xl-10 h-100">
    <div class="p-md-3">

        <div class="row">
            <div class="m-3 d-flex align-items-center justify-content-center col uploadfilecontainer" (click)="fileInputDB.click()">
                <input type="file" (change)="onFileChangeDB($event.target)" #fileInputDB>
                <mat-icon aria-label="add-image">cloud_upload</mat-icon> Parcourir les fichiers pour Indexed DB
            </div>
        </div>
        <div class="row">
            <div class="m-3 d-flex align-items-center justify-content-center col uploadfilecontainer" (click)="fileInputLS.click()">
                <input type="file" (change)="onFileChangeLocalStorage($event.target)" #fileInputLS>
                <mat-icon aria-label="add-image">cloud_upload</mat-icon> Parcourir les fichiers pour Local Storage
            </div>
        </div>

    </div>
</div>